/**
 * A date answer ("2026-11-03") as printed on the signed PDF: 11/03/2026. Read from its digits as
 * written, never through `new Date()`, which treats a date-only string as midnight UTC and prints
 * the day before in US time zones.
 */
export function printedDate(value: unknown): string | undefined {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value ?? ""));
  return match ? `${match[2]}/${match[3]}/${match[1]}` : undefined;
}
